@let choices = question().choices ?? [];

@if (isGrid()) {
  <tui-textfield multi tuiChevron [rows]="1" [stringify]="stringifyChoice">
    <input
      data-testid="checkbox-multiselect"
      ngDefaultControl
      tuiInputChip
      tuiSelectLike
      [ngModel]="selectedKeys()"
      [placeholder]="hasSelection() ? '' : placeholder()"
      [readOnly]="readOnly()"
      (ngModelChange)="onKeysChange($event)" />
    <tui-data-list-wrapper *tuiDropdown new tuiMultiSelectGroup [itemContent]="checkboxItem" [items]="choiceKeys()" />
  </tui-textfield>
  <ng-template #checkboxItem let-key>{{ stringifyChoice(key) }}</ng-template>
} @else {
  <div class="flex flex-wrap gap-2" [formGroup]="control()">
    @for (choice of choices; track choice.key) {
      <label tuiBlock="m">
        <input
          ngDefaultControl
          tuiCheckbox
          type="checkbox"
          [attr.data-testid]="choice.key"
          [formControlName]="choice.key"
          [readOnly]="readOnly()" />
        {{ choice.value }}
      </label>
    }
  </div>
}
